import { twMerge } from "tailwind-merge";
import { Check } from "lucide-react";
import { RequirementCheckBase, type RequirementCheckBaseProps } from "@core/ui";
import { Type } from "../Type";

export type Props = Omit<RequirementCheckBaseProps, "renderIcon" | "renderMessage"> & {
  /** Additional CSS classes for the message */
  captionClassName?: string;
};

/**
 * Styled requirement check component wrapping RequirementCheckBase.
 * Displays a validation indicator with a message.
 */
export function RequirementCheck({
  isMet,
  message,
  className,
  captionClassName,
  ...props
}: Props) {
  return (
    <RequirementCheckBase
      isMet={isMet}
      message={message}
      className={twMerge("flex items-start gap-2", className)}
      data-testid="requirement-check"
      renderIcon={({ isMet: met }) => (
        <div
          className={twMerge(
            "flex h-4 w-4 items-center justify-center rounded-full text-brand-50 shrink-0 relative top-0.5",
            met ? "bg-success" : "bg-brand-400"
          )}
        >
          <Check size={12} />
        </div>
      )}
      renderMessage={({ message: msg, className: msgClassName }) => (
        <Type variant="caption" className={twMerge(msgClassName, captionClassName)}>
          {msg}
        </Type>
      )}
      {...props}
    />
  );
}

export default RequirementCheck;

